const route = {
    path: ':codeProject/promotions',
    name: 'page-promotions',
    meta: {
        title: 'Promociones',
    },
    props: true,
    component: () => import('@/pages/promotions/page-promotions'),
    children: [
        {
            path: 'new',
            name: 'page-new-promotion',
            meta: {
                title: 'Agregar Promoción',
            },
            props: true,
            component: () => import('@/pages/promotions/page-new-promotion'),
        },
        {
            path: ':id/edit',
            name: 'page-edit-promotion',
            meta: {
                title: 'Editar Promoción',
            },
            props: true,
            component: () => import('@/pages/promotions/page-new-promotion'),
        },
        {
            path: ':id/details',
            name: 'page-promotion-details',
            meta: {
                title: 'Banners / Detalles',
            },
            props: true,
            component: () => import('@/pages/promotions-details/page-promotion-details'),
            children: [
                {
                    path: 'new',
                    name: 'page-new-promotion-detail',
                    meta: {
                        title: 'Agregar Detalle',
                    },
                    props: true,
                    component: () => import('@/pages/promotions-details/page-new-promotion-detail'),
                },
                {
                    path: ':detailId/edit',
                    name: 'page-edit-promotion-detail',
                    meta: {
                        title: 'Editar Detalle',
                    },
                    props: true,
                    component: () => import('@/pages/promotions-details/page-new-promotion-detail'),
                },
            ],
        },
    ],
};

export default route;



// WEBPACK FOOTER //
// ./src/router/promotions.js